import { render, staticRenderFns } from "./cta-button.vue?vue&type=template&id=a5336450&scoped=true&"
import script from "./cta-button.vue?vue&type=script&lang=js&"
export * from "./cta-button.vue?vue&type=script&lang=js&"
import style0 from "./cta-button.vue?vue&type=style&index=0&id=a5336450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5336450",
  null
  
)

export default component.exports